export default __webpack_public_path__ + "static/referencje-1-04b169e98cc89219671a6a4a950eb087.jpg";